import { render, staticRenderFns } from "./TransactionDetailModal.vue?vue&type=template&id=31ba9882"
import script from "./TransactionDetailModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailModal.vue?vue&type=style&index=0&id=31ba9882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports